export default {"src":"/_next/static/media/icon-lbma-logo.a4acfa50.svg","height":86,"width":112,"blurWidth":0,"blurHeight":0};